const features = [
  {
    icon: 'ri-timer-flash-line',
    title: '每日新鲜',
    desc: '全网热点实时追踪，每天更新最新八卦内容，绝不错过任何一个热门瓜，让你始终走在吃瓜第一线。',
  },
  {
    icon: 'ri-vip-diamond-line',
    title: '完全免费',
    desc: '无需注册、无需付费，打开浏览器就能畅快吃瓜。所有内容永久免费开放，不设任何付费墙。',
  },
  {
    icon: 'ri-global-line',
    title: '海量聚合',
    desc: '汇聚微博、抖音、小红书、豆瓣等多平台热门内容，一个入口看遍全网吃瓜精华，省时又省力。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-20 px-4 md:px-6 scroll-mt-20">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            平台特色
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            为什么百万瓜友选择在线吃瓜？三大理由告诉你答案
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {features.map((item, i) => (
            <div
              key={i}
              className="group bg-background-50 rounded-2xl p-6 md:p-8 border border-background-200/60 hover:border-primary-200/60 transition-all duration-300"
            >
              <div className="w-14 h-14 rounded-2xl bg-primary-100 flex items-center justify-center mb-5 group-hover:bg-primary-200 transition-colors">
                <i className={`${item.icon} text-primary-500 text-2xl`}></i>
              </div>
              <h3 className="text-lg font-semibold text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}